'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { JS, CSS as FOLDER_ASSET_TYPE_CSS } from 'DesignData/constants/FolderAssetTypes';
import * as DesignAssetTypes from 'DesignData/enums/DesignAssetTypes';
import { translateFolderPath } from 'DesignData/helpers/finderHelpers';
import ImmutableModel from 'DesignData/models/ImmutableModel';
export default class File extends ImmutableModel {
  static getDesignAssetType(type) {
    switch (type) {
      case FOLDER_ASSET_TYPE_CSS:
      case JS:
        {
          return DesignAssetTypes.TEMPLATE;
        }

      default:
        {
          return DesignAssetTypes[type] || null;
        }
    }
  }

  constructor(props) {
    const {
      folderPath: __folderPath
    } = props,
          rest = _objectWithoutPropertiesLoose(props, ["folderPath"]);

    const folderPath = __folderPath ? translateFolderPath(__folderPath) : null;
    return super(rest).set('__folderPath', folderPath);
  }

  get folderPath() {
    return this.__folderPath;
  }

  get designAssetType() {
    return File.getDesignAssetType(this.type);
  }

}